<a [customRouterLink]="productLink" class="product-card-container" #card>
  <div class="content {{scale}}">
    <div class="product-image-wrapper">
      <div class="label">
            <div class="sign" *ngFor="let label of product.productLabels">{{ label.localizedLabel }}</div>
      </div>
      <div class="product-image">
        <img
          *ngIf="product.images as images; else noImage"
          [lazyLoad]="images[0]?.url + '?height=400&width=400&padColor=fff'"
          [defaultImage]="images[0]?.url + '?height=50&width=50&padColor=fff'"
          errorImage="./assets/ui/shared/error/not_found_error_image.png"
          src="#"
          [alt]="product.name"
          [title]="product.name"
          width="100%" height="100%"/>
        <ng-template #noImage>
          <img
            lazyLoad="./assets/ui/shared/error/not_found_error_image.png"
            defaultImage="./assets/ui/shared/error/not_found_error_image.png"
            errorImage="./assets/ui/shared/error/not_found_error_image.png"
            src="#"
            [alt]="product.name"
            [title]="product.name"
            width="100%" height="100%"/>
        </ng-template>
      </div>
    </div>
    <kion-icon-bar
      [icons]="icons$ | async"
      [scale]="this.scale"
    ></kion-icon-bar>
    <div class="text">{{ product.name }}</div>
    <div class="price-bar">
      <kion-price
        *ngIf="price else priceOnRequest"
        [price]="price.price"
        [strikedPrice]="price.strikedPrice"
        [isRanged]="price.isRanged"
        [sameLine]="true"
        [type]="scale"
      ></kion-price>
      <ng-template #priceOnRequest>
        <kion-price
          [isRanged]="false"
          [sameLine]="true"
          [type]="scale"
          [priceOnRequest]="'productCard.price.priceOnRequest.description' | translate"
        ></kion-price>
      </ng-template>
    </div>
  </div>
</a>
